define('ProductDetails.Base.View.MetaData', [
    'ProductDetails.Base.View',
    'jQuery',
    'underscore'
], function ProductDetailsBaseViewMetaData(
    ProductDetailsBaseView,
    jQuery,
    _
) {
    'use strict';

    _.extend(ProductDetailsBaseView.prototype, {
        getMetaTags: function getMetaTags() {
            return jQuery('<head/>').html(
                jQuery.trim(
                    this.model.get('item').get('_metaTags')
                ).replace(/\u00a0/g, ' ')
            ).children('meta');
        }
    });
});

